import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import store from 'src/services/redux/app/Store';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;

interface IState {
  data: [];
  loading: boolean;
  done: boolean;
  showError: boolean;
  error: any;
}

const initialState: IState = {
  data: [],
  loading: false,
  done: false,
  error: null,
  showError: false,
};

export const inventoryExport = createAsyncThunk('inventory/export', async (data: any) => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get(`${VENDOR_MC_URL}/vendor/${userId}/inventory/export?${data}`);
  return res.data;
});

const inventoryExportSlice = createSlice({
  name: 'productReviews',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.showError = action.payload;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(inventoryExport.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(inventoryExport.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.done = true;
    });
    builder.addCase(inventoryExport.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Excel oluşturulamadı.';
      state.data = [];
    });
    //
  },
});
export const { setError } = inventoryExportSlice.actions;
export default inventoryExportSlice.reducer;
